import { render } from "./WhatsNewBanner.vue?vue&type=template&id=278c883d"
import script from "./WhatsNewBanner.vue?vue&type=script&lang=js"
export * from "./WhatsNewBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__